import React from "react";
import "./Portfolio.css";

function Portfolio() {
  const clients = [
    {
      name: "ETG Curechem",
      logo: "/images/etg-curechem-logo.png",
    },
    {
      name: "Reload",
      logo: "/images/reload-logo.png",
    },
  ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <div className="section-title">
          <h2>Companies We've Worked With</h2>
          <p>Partnering with industry leaders to deliver exceptional results</p>
        </div>

        <div className="client-logos">
          {clients.map((client, index) => (
            <div key={index} className="client-logo-wrapper">
              <img
                src={client.logo}
                alt={client.name}
                className="client-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
